import React from 'react';
import { Switch } from 'react-router-dom';
import { home } from '../config';
import Route from './routes';
import SignIn from '../pages/SignIn';
import Sobre from '../pages/Sobre';
import SignInAdmin from '../pages/SignInAdmin';
import SignUp from '../pages/SignUp';
import RecoverPassword from '../pages/RecoverPassword';
import ResetPassword from '../pages/ResetPassword';
import Products from '../pages/Products';

import VideosDashboard from '../pages/VideosDashboard';
import Dashboard from '../pages/DashboardPages';

import Home from '../pages/Home';
import AreaExposicao from '../pages/AreaExposicao';
import Expositor from '../pages/Expositor';
import Galeria from '../pages/Galeria';
import ExpositorChat from '../pages/ExpositorChat';
import SigninExpositor from '../pages/SigninExpositor';
import Program from '../pages/Program';
import Poster from '../pages/Poster';

import Validate from '../pages/Validate';
import Zoom from '../components/ZoomStarter';
import SpeakerLink from '../pages/SpeakerLink';
import ModeratorLink from '../pages/ModeratorLink';
import Termos from '../pages/Termos';
import Submission from '../pages/DashboardPages/features/Cientific/pages/Home';
import PaymentMethod from '../pages/Products/modules/PaymentMethod';
import PaymentConfirmation from '../pages/Products/modules/PaymentConfirmation';

import AvaliatorSubscription from '../pages/Cientific/Pages/AvaliatorSubscription';
import AreaAvaliador from '../pages/DashboardPages/features/Cientific/pagesAvaliador/Home';
import LoginAvaliador from '../pages/DashboardPages/features/Cientific/pagesAvaliador/SignIn';
import Certificados from '../pages/Certificados';

const ValidPaths = {
  SignIn,
  SignInAdmin,
  SignUp,
  RecoverPassword,
  ResetPassword,
  Products,
  VideosDashboard,
 
  Home,
  Sobre,
};

const Routes: React.FC = () => {
  return (
    <Switch>
      <Route
        
        path="/"
        exact
        component={ValidPaths[home] ? ValidPaths[home] : Home}
      />
 <Route  path="/certificados" component={Certificados} /> 


 { /* científico */ }
 <Route  path="/area-avaliador/:tab" component={AreaAvaliador} />  
 <Route  path="/area-avaliador" component={AreaAvaliador} />  
 <Route  path="/cadastro-de-avaliador" component={AvaliatorSubscription} />
 <Route  path="/login-avaliador" component={LoginAvaliador} />     

<Route path="/checkout/:product_hash" component={PaymentMethod} />
      <Route path="/payment/success/:payment_hash" component={PaymentConfirmation} />

   <Route path="/recuperar_senha" component={RecoverPassword} />
      <Route path="/reset_password/:key?" component={ResetPassword} />
      <Route isPrivate  path="/trabalhos/:tab/:id" component={Submission} />
      <Route isPrivate  path="/trabalhos/:tab" component={Submission} />
<Route isPrivate  path="/trabalhos" component={Submission} />



      <Route  path="/login" component={SignIn} />
      <Route isPrivate path="/poster" component={Poster} />
      <Route template="client" path="/validate/:hash" component={Validate} />
      <Route template="client" path="/events/access/:hash" component={SpeakerLink} />
       <Route path="/zoom" component={Zoom} />

     <Route template="client" path="/moderator/access/:hash" component={ModeratorLink} />
     <Route  path="/inscricao" component={SignUp} />
      <Route  path="/exposicao" component={AreaExposicao} />
      <Route  path="/termos" component={Termos} />
      <Route  path="/programacao" component={Program} />
      <Route template="client" path="/admin" component={SignInAdmin} />
      <Route isPrivate path="/login_expositor" component={SigninExpositor} />
      <Route isPrivate path="/mostra" component={Sobre} />
      <Route
        
        path="/expositores/:link_name"
        template="page"
        component={ExpositorChat}
      />
      <Route
        isPrivate
        path="/galeria/:link_name"
        template="page"
        component={Galeria}
      />
      <Route
        isPrivate
        path="/expositores_chat/:link_name"
        template="page"
        component={ExpositorChat}
      />
      <Route
        isPrivate
        path="/dashboard/:videoIdItem"
        component={VideosDashboard}
      />
      <Route path="/dashboard" isPrivate component={VideosDashboard} />

      <Route
        path="/manager/:tab"
        template="dashboard"
        isPrivate
        isSecret
        component={Dashboard}
      />
      <Route
        path="/manager"
        template="dashboard"
        isPrivate
        exact
        isSecret
        component={Dashboard}
      />
   
 
    </Switch>
  );
};

export default Routes;
